import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "redux/store.types";

const campaignsStateSelector = (state: RootState) => state.campaigns;

export const activeFilterTypeSelector = createSelector(
	campaignsStateSelector,
	(state) => state.activeFilterType,
);

export const pageNumberSelector = createSelector(
	campaignsStateSelector,
	(state) => state.pagination.pageNumber,
);

export const campaignModalsSelector = createSelector(
	campaignsStateSelector,
	(state) => state.modals,
);

export const selectedCampaignSelector = createSelector(
	campaignsStateSelector,
	(state) => state.selectedCampaign,
);

export const draftCampaignSelector = createSelector(
	campaignsStateSelector,
	(state) => state.draftCampaign,
);
